import { render, staticRenderFns } from "./ChartsBI.vue?vue&type=template&id=2da6be8d&scoped=true&"
import script from "./ChartsBI.vue?vue&type=script&lang=js&"
export * from "./ChartsBI.vue?vue&type=script&lang=js&"
import style0 from "./ChartsBI.vue?vue&type=style&index=0&id=2da6be8d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2da6be8d",
  null
  
)

export default component.exports